import { Accordion } from "./Accordion";
import { Button } from "./Button";
import { CloseButton } from "./CloseButton";
import { Heading } from "./Heading";
import { Link } from "./Link";
import { Tabs } from "./Tabs";
import { Text } from "./Text";

export const components = { Accordion, Button, CloseButton, Heading, Link, Tabs, Text };
